<script setup>
import VInputReadonlyWithBlockLabel from "../../Form/Survey/VInputReadonlyWithBlockLabel.vue";

import { useForm } from "@inertiajs/vue3";
import VMultiShow from "../../Form/Survey/VMultiShow.vue";

const props = defineProps({
    additional: Object,
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    why_did_you_select_sabah_as_a_holidayvacation_destination:
        answers?.why_did_you_select_sabah_as_a_holidayvacation_destination ??
        [],
    what_influenced_you_to_choose_sabah_as_holidayvacation_destination:
        answers?.what_influenced_you_to_choose_sabah_as_holidayvacation_destination ??
        [],
    how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah:
        answers?.how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah,
    travel_companion: answers?.travel_companion ?? [],
    what_did_you_manage_to_do_during_this_trip_in_sabah:
        answers?.what_did_you_manage_to_do_during_this_trip_in_sabah ?? [],
    where_did_you_stay_during_this_trip:
        answers?.where_did_you_stay_during_this_trip ?? [],
    what_did_you_buy_while_visiting_sabah:
        answers?.what_did_you_buy_while_visiting_sabah ?? [],
    please_specify_your_place_of_shopping:
        answers?.please_specify_your_place_of_shopping ?? [],
});

const emits = defineEmits("onNext");

const handleClickNext = () => {
    emits("onNext", form.data());
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-4">
                    <VMultiShow
                        elId="why_did_you_select_sabah_as_a_holidayvacation_destination"
                        v-model:value="
                            form.why_did_you_select_sabah_as_a_holidayvacation_destination
                        "
                        :label="
                            surveyFields[
                                'why_did_you_select_sabah_as_a_holidayvacation_destination'
                            ]?.name
                        "
                        :options="
                            form.why_did_you_select_sabah_as_a_holidayvacation_destination
                        "
                    />
                </div>
                <div class="mb-4">
                    <VMultiShow
                        elId="what_influenced_you_to_choose_sabah_as_holidayvacation_destination"
                        v-model:value="
                            form.what_influenced_you_to_choose_sabah_as_holidayvacation_destination
                        "
                        :label="
                            surveyFields[
                                'what_influenced_you_to_choose_sabah_as_holidayvacation_destination'
                            ]?.name
                        "
                        :options="
                            form.what_influenced_you_to_choose_sabah_as_holidayvacation_destination
                        "
                    />
                </div>
                <div class="mb-4">
                    <VInputReadonlyWithBlockLabel
                        elId="how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah"
                        v-model:value="
                            form.how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah
                        "
                        :label="
                            surveyFields[
                                'how_long_did_it_take_you_to_plan_and_booking_your_holidayvacation_to_sabah'
                            ]?.name
                        "
                        :isPlainText="false"
                    />
                </div>
                <div class="mb-4">
                    <VMultiShow
                        elId="travel_companion"
                        v-model:value="form.travel_companion"
                        :label="surveyFields['travel_companion']?.name"
                        :options="form.travel_companion"
                    />
                </div>
                <div class="mb-4">
                    <VMultiShow
                        elId="what_did_you_manage_to_do_during_this_trip_in_sabah"
                        v-model:value="
                            form.what_did_you_manage_to_do_during_this_trip_in_sabah
                        "
                        :label="
                            surveyFields[
                                'what_did_you_manage_to_do_during_this_trip_in_sabah'
                            ]?.name
                        "
                        :options="
                            form.what_did_you_manage_to_do_during_this_trip_in_sabah
                        "
                    />
                </div>
                <div class="mb-4">
                    <VMultiShow
                        elId="where_did_you_stay_during_this_trip"
                        v-model:value="form.where_did_you_stay_during_this_trip"
                        :label="
                            surveyFields['where_did_you_stay_during_this_trip']
                                ?.name
                        "
                        :options="form.where_did_you_stay_during_this_trip"
                    />
                </div>
                <div class="mb-4">
                    <VMultiShow
                        elId="what_did_you_buy_while_visiting_sabah"
                        v-model:value="
                            form.what_did_you_buy_while_visiting_sabah
                        "
                        :label="
                            surveyFields[
                                'what_did_you_buy_while_visiting_sabah'
                            ]?.name
                        "
                        :options="form.what_did_you_buy_while_visiting_sabah"
                    />
                </div>
                <div class="mb-4">
                    <VMultiShow
                        elId="please_specify_your_place_of_shopping"
                        v-model:value="
                            form.please_specify_your_place_of_shopping
                        "
                        :label="
                            surveyFields[
                                'please_specify_your_place_of_shopping'
                            ]?.name
                        "
                        :options="form.please_specify_your_place_of_shopping"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
